module.exports = __webpack_public_path__ + "img/mini-success.6310d177.svg";